import { render, staticRenderFns } from "./sliderImages.vue?vue&type=template&id=344a37ab"
import script from "./sliderImages.vue?vue&type=script&lang=js"
export * from "./sliderImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports